export default "__VITE_ASSET__45130930__"